<template>
  <div class="list">
    <div
      :style="{ width: `${100 / colNum}%` }"
      @click="handlClick(item, index)"
      @dragenter="dragenter($event, index)"
      @dragover="dragover($event, index)"
      @dragstart="dragstart(index)"
      @dragend="dragend(index)"
      draggable
      v-for="(item, index) in modelData"
      :key="item.label"
      class="list-item"
    >
      {{ item.label }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    modelData: {
      type: Array,
      default: function () {
      return [];
    }
    },
    colNum: {
      type: Number,
      default: 4
    }
  },
  data () {
    return {
      list: [
        { label: "列表1" },
        { label: "列表2" },
        { label: "列表3" },
        { label: "列表4" },
        { label: "列表5" },
        { label: "列表6" },
        { label: "列表7" },
        { label: "列表8" },
        { label: "列表9" }
      ],
      dragIndex: "",
      enterIndex: ""
    };
  },
  methods: {
    // 源对象开始被拖动时触发
    dragstart (index) {
      this.dragIndex = index;
    },
    // 源对象开始进入目标对象范围内触发
    dragenter (e, index) {
      e.preventDefault();
      // 避免源对象触发自身的dragenter事件
      // if (this.dragIndex !== index) {
      //   const source = this.modelData[this.dragIndex];
      //   this.modelData.splice(this.dragIndex, 1);
      //   this.modelData.splice(index, 0, source);
      //   // 排序变化后目标对象的索引变成源对象的索引
      //   this.dragIndex = index;
      // }
    },
    // 源对象在目标对象范围内移动时触发
    dragover (e, index) {
      e.preventDefault();
      this.enterIndex = index
      // if (this.dragIndex !== index) {
      //   // 交换元素位置
      //   let temp = this.modelData[this.dragIndex];
      // //  this.modelData[this.dragIndex] = this.modelData[index];
      //   //this.modelData[index] = temp;

      //   this.$set(this.modelData, this.dragIndex, this.modelData[index]);
      //   this.$set(this.modelData, index, temp);
      // }
    },
    dragend (val) {
      // e.preventDefault();
      const index = this.enterIndex
      if (this.dragIndex !== index) {
        // 交换元素位置
        const temp = this.modelData[this.dragIndex];
      //  this.modelData[this.dragIndex] = this.modelData[index];
        // this.modelData[index] = temp;

        this.$set(this.modelData, this.dragIndex, this.modelData[index]);
        this.$set(this.modelData, index, temp);
      }
    },
    handlClick (item, index) {
      this.$emit("itemOnClick", { item, index });
    }
  }
};
</script>
<style scoped>
.list {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.list-item {
  width: 25%;
  cursor: move;
  background: hsl(0, 1%, 71%);
  color: #fff;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border: 0.5px solid rgb(117, 117, 117);
}
</style>
